<template>
  <div class="select-type" :style="{height: viewportHeight}">
    <HomeHeader :scrollTop="300"></HomeHeader>
    <div class="flex-column container w-wrapper">
      <div v-if="false" @click="goBack()" class="back">返回</div>
      <div class="flex-column main">
        <div class="title">企业MCN机构申请</div>
        <div class="steps-box">
          <el-steps :active="1" align-center>
            <el-step title="选择公会类型"></el-step>
            <el-step title="填写公会信息"></el-step>
            <el-step title="填写资质信息"></el-step>
            <el-step title="确认信息"></el-step>
            <el-step title="等待审核"></el-step>
            <el-step title="完成入驻"></el-step>
          </el-steps>
        </div>
        <div class="form-box">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="" label-width="0">
              <div style="font-weight: bold;width: 100px;text-align: right;font-size: 16px;">负责人信息</div>
            </el-form-item>
            <el-form-item label="负责人姓名" prop="contactName">
              <el-input v-model.trim="ruleForm.contactName" placeholder="请输入" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="负责人身份" prop="contactRole">
              <el-select style="width: 100%;" v-model="ruleForm.contactRole" placeholder="请选择">
                <el-option label="省级代理人" :value="4"></el-option>
                <el-option label="市级代理人" :value="3"></el-option>
                <el-option label="区县代理人" :value="2"></el-option>
                <el-option label="无" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号码" prop="contactPhone">
              <el-input
                  v-model.trim="ruleForm.contactPhone"
                  placeholder="请输入"
                  @blur="getImgVerifyCodeApi()"
                  maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="图形验证码" prop="code">
              <div class="flex-row-h-center">
                <div style="flex: 1;">
                  <el-input v-model.trim="ruleForm.code" placeholder="请输入" maxlength="4"></el-input>
                </div>
                <div style="width: 100px;margin-left: 10px;text-align: right;cursor: pointer;">
                  <img
                      v-if="ruleForm.contactPhone && ruleForm.contactPhone.length === 11 && imgCodeUrl"
                      @click="getImgVerifyCodeApi()"
                      style="width: 100px;"
                      :src="imgCodeUrl" alt="">
                  <span v-else-if="!ruleForm.contactPhone">请输入手机号</span>
                  <span v-else>获取图形验证码</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="短信验证码" prop="smsCode">
              <div class="flex-row-h-center">
                <div style="flex: 1;">
                  <el-input v-model.trim="ruleForm.smsCode" placeholder="请输入" maxlength="6"></el-input>
                </div>
                <div style="margin-left: 10px;">
                  <el-button @click="getSMSVerifyCodeApi()">{{
                      countdown > 0 ? `${countdown}秒后重试` : '获取短信验证码'
                    }}
                  </el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="身份证照片" required>
              <div class="flex-row">
                <directUploadOne
                    model="img"
                    size="10MB"
                    @success="ocrIdCardApi()"
                    :defaultImgUrl="id_card_face"
                    :imgUrl.sync="ruleForm.contactIdCardFrontUrl"/>
                <directUploadOne
                    style="margin-left: 10px;"
                    model="img"
                    size="10MB"
                    :defaultImgUrl="id_card_country"
                    :imgUrl.sync="ruleForm.contactIdCardBackUrl"/>
              </div>
            </el-form-item>
            <el-form-item label="身份证号码" prop="contactIdCard">
              <el-input v-model.trim="ruleForm.contactIdCard" placeholder="请输入" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="" label-width="0">
              <div style="font-weight: bold;width: 100px;text-align: right;font-size: 16px;">公会信息</div>
            </el-form-item>
            <el-form-item label="公会名称" prop="orgName">
              <el-input
                  v-model.trim="ruleForm.orgName"
                  placeholder="请输入"
                  @blur="joinApplyNameCheckApi()"
                  maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="公会介绍" prop="orgDescription">
              <el-input
                  type="textarea"
                  show-word-limit
                  rows="5"
                  placeholder="请输入"
                  v-model.trim="ruleForm.orgDescription"
                  maxlength="200"></el-input>
            </el-form-item>
            <el-form-item>
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-button
                      style="width: 100%"
                      type="default"
                      @click="onPre()">上一步
                  </el-button>
                </el-col>
                <el-col :span="8">
                  <el-button
                      style="width: 100%"
                      type="primary"
                      @click="submitForm()">下一步
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
        title="请上传负责人证件"
        :visible.sync="ocrVisible"
        width="30%">
      <div>
        <div>检测到您上传的身份证照片中的姓名和负责人姓名不一致，是否覆盖负责人姓名</div>
        <div slot="footer" class="flex-row-end dialog-footer">
          <el-button @click="handleConfirmOcr(1)">不覆盖</el-button>
          <el-button type="primary" @click="handleConfirmOcr(2)">覆 盖</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HomeHeader from "@/views/home/components/home-header";
import {decryptECB, encryptECB} from "@/utils/parsing";
import {
  getImgVerifyCode,
  stepOneSave,
  getSMSVerifyCode,
  joinApplyNameCheck,
  ocrIdCard,
  joinApplyProgress
} from "@/apis/audit";
import id_card_face from '@/assets/entryApplication/id_card_face.png'
import id_card_country from '@/assets/entryApplication/id_card_country.png'
import {getItem} from "@/utils/storage";
import {isMobile, validateIdCard, validateText2} from "@/utils/validate";

export default {
  name: "select-type",
  components: {HomeHeader},
  data() {
    return {
      applyDetail: {}, // 申请详情
      ocrData: {}, // ocr识别数据
      ocrVisible: false, // 是否覆盖负责人姓名弹窗
      countdown: 0, // 倒计时
      timer: null, // 定时器
      applyId: '', // 入驻申请id
      colSpan: 14,
      viewportHeight: '100vh',
      imgCodeUrl: '', // 图形验证码
      imgKey: '', // 图形验证码的key
      contactIdCardFrontUrlList: [],
      id_card_face: id_card_face,
      id_card_country: id_card_country,
      ruleForm: {
        contactName: '', //	负责人姓名	true string
        contactRole: '', //	负责人身份 1-无 2-区县代理人 3-市级代理人 4-省级代理人		true integer(int32)
        contactPhone: '',	// 负责人手机号码, aes加密		true string
        smsCode: '', //	短信验证码		true string
        smsKey: '', //	获取验证码时的Key
        contactIdCardFrontUrl: '', 	// 负责人身份证-正面		true string
        contactIdCardBackUrl: '',	// 负责人身份证-背面		true string
        contactIdCard: '',	// 负责人身份证号码		true string
        orgName: '', //	机构名称		true string
        orgDescription: '', // 	机构介绍		true string
        mcnType: '1', //	公会类型 1-企业 2-个人		true integer(int32)
      },
      rules: {
        contactName: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        contactRole: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        contactPhone: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        smsCode: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        contactIdCard: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        orgName: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        orgDescription: [
          {required: true, message: '请输入', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    if (this.$route.query.mcnType) {
      this.ruleForm.mcnType = this.$route.query.mcnType
    }
    this.joinApplyProgressApi()
  },
  mounted() {
    let viewportHeight = document.documentElement.clientHeight;
    this.viewportHeight = viewportHeight + 'px'
  },
  methods: {
    // 覆盖身份信息
    handleConfirmOcr(type) {
      if (type === 2) {
        this.ruleForm.contactName = this.ocrData.contactName
        this.ruleForm.contactIdCard = this.ocrData.idCard
      }
      if (type === 1 && !this.ruleForm.contactIdCard) {
        this.ruleForm.contactIdCard = this.ocrData.idCard
      }
      this.ocrVisible = false
    },
    // 获取入驻进度
    joinApplyProgressApi() {
      const applyId = getItem('applyId')
      if (!applyId) {
        return
      }
      this.applyId = applyId
      joinApplyProgress({applyId: this.applyId}).then(res => {
        const data = res.data || {}
        if (!this.$route.query.mcnType && data.mcnType) {
          this.ruleForm.mcnType = data.mcnType
        }
        this.applyDetail = data
        this.ruleForm.contactName = data.contactName || ''
        this.ruleForm.contactRole = data.contactRole || ''
        this.ruleForm.contactPhone = data.contactPhone || ''
        this.ruleForm.contactIdCardFrontUrl = data.contactIdCardFrontUrl || ''
        this.ruleForm.contactIdCardBackUrl = data.contactIdCardBackUrl || ''
        this.ruleForm.contactIdCard = data.contactIdCard || ''
        this.ruleForm.orgName = data.orgName || ''
        this.ruleForm.orgDescription = data.orgDescription || ''
        if (data.contactPhone) {
          this.getImgVerifyCodeApi()
        }
      })
    },
    // ocr识别身份证
    ocrIdCardApi() {
      if (!this.ruleForm.contactIdCardFrontUrl) {
        return
      }
      ocrIdCard(encryptECB(this.ruleForm.contactIdCardFrontUrl)).then(res => {
        const contactName = decryptECB(res.data.name)
        const idCard = decryptECB(res.data.idCard)
        if (!this.ruleForm.contactName) {
          this.ruleForm.contactName = contactName
          this.ruleForm.contactIdCard = idCard
          return
        }
        if (this.ruleForm.contactName === contactName) {
          this.ruleForm.contactIdCard = idCard
          return;
        }
        this.ocrData = {
          ...res.data,
          contactName: contactName,
          idCard: idCard
        }
        this.ocrVisible = true

        // console.log(contactName)
        // console.log(idCard)


        // if (this.ruleForm.contactIdCard !== idCard) {
        //   this.$message({
        //     message: '身份证号码与输入号码不一致',
        //     type: 'warning'
        //   })
        // }
        // this.ruleForm.contactIdCard = decryptECB(res.data.idCard)
      })
    },
    // 后端接口检查名称是否存在
    joinApplyNameCheckApi() {
      const orgName = this.ruleForm.orgName
      const contactPhone = this.ruleForm.contactPhone
      if (!contactPhone) {
        return this.$message({
          message: '请输入手机号码',
          type: 'warning'
        })
      }
      if (!orgName) {
        return this.$message({
          message: '请输入公会名称',
          type: 'warning'
        })
      }
      joinApplyNameCheck({
        name: orgName,
        phone: encryptECB(contactPhone)
      }).then(res => {
        if (!res.data) {
          this.$message({
            message: '该名称已被占用，请重新输入',
            type: 'warning'
          })
        }
      })
    },
    // 获取图形验证码
    getImgVerifyCodeApi() {
      if (!this.ruleForm.contactPhone) {
        return this.$message({
          message: '请输入手机号码',
          type: 'warning'
        })
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      getImgVerifyCode({
        phone: encryptECB(this.ruleForm.contactPhone)
      }).then(res => {
        this.imgCodeUrl = res.data.code
        this.imgKey = res.data.key
      }).finally(() => {
        loading.close()
      })
    },
    // 获取短信验证码
    getSMSVerifyCodeApi() {
      if (!this.ruleForm.code) {
        return this.$message({
          message: '请输入图文验证码',
          type: 'warning'
        })
      }
      if (this.countdown > 0) return; // 防抖处理
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.5)',
        customClass: 'global-loading', // 设置最高层级，防止弹窗把loading覆盖
      })
      getSMSVerifyCode({
        code: this.ruleForm.code,
        key: this.imgKey,
        phone: encryptECB(this.ruleForm.contactPhone)
      }).then((res) => {
        this.ruleForm.smsKey = res.data.key
        this.$message({
          message: '验证码已发送，请注意查收',
          type: 'success'
        });
        this.countdown = 60;
        this.timer = setInterval(() => {
          if (this.countdown <= 0) {
            clearInterval(this.timer);
          } else {
            this.countdown--;
          }
        }, 1000);
      }).catch((err) => {
        if (err.code === 151023) {
          this.getImgVerifyCodeApi()
        }
        this.countdown = 0;
      }).finally(() => {
        loading.close()
      })
    },
    // 上一步
    onPre() {
      this.$confirm('离开当前页面，数据将会丢失, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.replace({
          path: '/apply/select'
        })
      })
    },
    // 提交表单
    submitForm() {
      if (!this.ruleForm.smsKey) {
        return this.$message({
          message: '请先获取短信验证码',
          type: 'warning'
        })
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!isMobile(this.ruleForm.contactPhone)) {
            return this.$message({
              message: '请输入正确的手机号码',
              type: 'warning'
            })
          }
          if (!validateIdCard(this.ruleForm.contactIdCard)) {
            return this.$message({
              message: '请输入正确的身份证号码',
              type: 'warning'
            })
          }
          if (!validateText2(this.ruleForm.contactName)) {
            return this.$message({
              message: '负责人姓名只能包含中英文和数字',
              type: 'warning'
            })
          }
          if (!validateText2(this.ruleForm.orgName)) {
            return this.$message({
              message: '公会名称只能包含中英文和数字',
              type: 'warning'
            })
          }
          this.stepOneSaveApi()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 保存第一步数据
    stepOneSaveApi() {
      const orgName = this.ruleForm.orgName
      const contactPhone = this.ruleForm.contactPhone
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.5)',
        customClass: 'global-loading', // 设置最高层级，防止弹窗把loading覆盖
      })
      joinApplyNameCheck({
        name: orgName,
        phone: encryptECB(contactPhone)
      }).then(res => {
        if (!res.data) {
          return this.$message({
            message: '该名称已被占用，请重新输入',
            type: 'warning'
          })
        }
        stepOneSave({
          ...this.ruleForm,
          version: this.applyDetail.version || 0, // 版本号
          contactPhone: encryptECB(this.ruleForm.contactPhone)
        }).then(res => {
          if (res.data && typeof res.data === "boolean" && res.data === false) {
            this.$message.warning('数据已更新，正在为您刷新页面')
            return setTimeout(() => {
              this.$router.go(0)
            }, 2000)
          }
          const data = res.data || {}
          console.log(data)
          if (data.token) {
            this.$store.commit('common/setToken', data.token)
          }
          if (data.applyId) {
            this.$store.commit('common/setApplyId', data.applyId)
          }
          this.$router.replace({
            path: '/apply/step-two'
          })
        }).catch((err) => {
          if (err.data && typeof err.data === "boolean" && err.data === false) {
            setTimeout(() => {
              this.$router.go(0)
            }, 2000)
          }
        }).finally(() => {
          loading.close()
        })
      }).finally(() => {
        loading.close()
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    goStepOne(type) {
      this.$router.push({
        path: '/apply/step-one',
        query: {
          mcnType: type
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-type {
  position: relative;
  overflow: hidden;
  background-image: url("~@/assets/banner.png");
  background-size: 100% 600px;
  background-repeat: no-repeat;
}

.container {
  margin: 60px auto 0;
  height: calc(100% - 100px);

  .back {
    padding: 16px 16px 16px 0;
    width: max-content;
    font-size: 16px;
    cursor: pointer;
  }

  .main {
    overflow-y: hidden;
    flex: 1;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 20px 0;
    border-radius: 4px;
    background-color: #ffffff;

    .steps-box {
      width: 800px;
      margin: 0 auto;
    }

    .form-box {
      flex: 1;
      overflow-y: auto;
      margin: 20px 0 0;
      padding: 30px 240px 20px;
    }

    .title {
      margin-bottom: 30px;
      font-size: 24px;
      text-align: center;
      font-weight: bold;
    }

    .type-item {
      margin: 20px 0;
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 5px;
      border: 1px solid transparent;
      cursor: pointer;

      &:hover {
        border-color: #409EFF;
      }
    }
  }
}

.dialog-footer {
  padding-top: 30px;
}
</style>